enum TipoBeneficioEnum {
  IngresoTardio = 1,
  Fallecimiento = 2,
  Cesantia = 6,
  VejezAnticipada = 5,
  // Sobrevivencia = 7,
}

export default TipoBeneficioEnum;
